export default __webpack_public_path__ + "static/media/loading.fea84465.GIF";